import { SessionStore } from '../../constants';
import { ExperienceInitCookie } from '../interfaces/experienceInitCookie';
import { getCookie } from './cookies';

/** Method to get experience init cookies */
export const getExperienceInitCookie = (): ExperienceInitCookie | undefined => {
  const tcPlusFlow = getCookie('TcPlusFlag') === '1';

  let initialCookies: ExperienceInitCookie;
  const experienceProps = tcPlusFlow
    ? sessionStorage.getItem(SessionStore.experienceProps)
    : getCookie('experience_props');

  if (experienceProps) {
    try {
      initialCookies = JSON.parse(
        // Removing extra double quotes and backslashes
        experienceProps.replace(/^"|"$/g, '').replace(/\\/g, ''),
      );
      return initialCookies;
    } catch (error) {
      console.error('Cookie parse error: ', error);
    }
  }
};
